import { CascoPackage, ParkingModeEnum } from '@insurance/api/requests'
import { RadioCardGroup } from '@insurance/components'
import { useValidationsField } from '@insurance/hooks'
import { Form } from 'antd'
import { useTranslation } from 'react-i18next'

import { useCascoInsuranceValues } from './CascoInsuranceContext'
import { formProps } from './utils'

export const ParkingMode = () => {
  const { t } = useTranslation()
  const { parkingModeProps, insurancePackageProps } = formProps(t)
  const { required } = useValidationsField()
  const { isEditable } = useCascoInsuranceValues()
  const insurancePackage = Form.useWatch(insurancePackageProps.name, {
    preserve: true
  })

  if (insurancePackage === CascoPackage.MINI) return null

  const options = Object.values(ParkingModeEnum).map((value) => ({
    label: t(value),
    value
  }))

  return (
    <Form.Item {...parkingModeProps} rules={[required]}>
      <RadioCardGroup disabled={isEditable} options={options} />
    </Form.Item>
  )
}
